import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { collection, getDocs } from 'firebase/firestore';

import { db } from '../../app/firebase';

const tsToMillis = (ts) => (ts && typeof ts.toMillis === 'function' ? ts.toMillis() : null);

const normalizeFaqItem = (id, data) => ({
  id,
  question: data.question || {},
  answer: data.answer || {},
  order: typeof data.order === 'number' ? data.order : 0,
  webOnly: data.webOnly === true,
  mobileOnly: data.mobileOnly === true,
  telegramOnly: data.telegramOnly === true,
  createdAt: tsToMillis(data.createdAt),
  updatedAt: tsToMillis(data.updatedAt),
});

const sortFaqItems = (list) =>
  [...list].sort((a, b) => {
    const ao = a.order ?? Number.MAX_SAFE_INTEGER;
    const bo = b.order ?? Number.MAX_SAFE_INTEGER;
    if (ao !== bo) return ao - bo;
    return a.id.localeCompare(b.id);
  });

export const fetchFaqItems = createAsyncThunk('faq/fetchAll', async () => {
  const snap = await getDocs(collection(db, 'faqItems'));
  const list = snap.docs.map((d) => normalizeFaqItem(d.id, d.data()));
  return sortFaqItems(list);
});

const initialState = {
  items: [],
  loadingList: false,
  error: null,
};

const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    resetFaqState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqItems.pending, (state) => {
        state.loadingList = true;
        state.error = null;
      })
      .addCase(fetchFaqItems.fulfilled, (state, action) => {
        state.loadingList = false;
        state.items = action.payload;
      })
      .addCase(fetchFaqItems.rejected, (state, action) => {
        state.loadingList = false;
        state.error = action.error?.message || 'Failed to load FAQ';
      });
  },
});

export const { resetFaqState } = faqSlice.actions;

export const selectFaqItems = (state) => state.faq.items;
export const selectFaqLoading = (state) => state.faq.loadingList;
export const selectFaqError = (state) => state.faq.error;

export default faqSlice.reducer;
